import { Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const ConfirmActionModal = ({ title, message, show, onClose, onConfirm, hideCancel, warning = false }) => {
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    if (show) {
      setIsConfirming(false);
    }
  }, [show]);

  const handleConfirm = () => {
    setIsConfirming(true);
    onConfirm();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>
          <div className="d-flex">
            {warning && <div className="warning pe-1" />}
            {title}
          </div>
        </Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          {!hideCancel ? (
            <button className="epo-continue-button small-button" type="button" onClick={onClose}>
              Cancel
            </button>
          ) : (
            <span></span>
          )}
          <button
            className="blue-button-newload small-button"
            type="button"
            onClick={handleConfirm}
            disabled={isConfirming}
          >
            Confirm
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
